<template>
  <div class="dim" id="pop-customer" style="display: block">
    <div class="popup-policy">
      <h2>
        오프라인 고객 등록
        <button class="btn-x" @click="fnClose">x버튼</button>
      </h2>
      <section class="inner">
        <div class="info-box-popup">
          <h3 class="page-title-popup">고객정보</h3>
          <dl class="info-txt">
            <dt>이름</dt>
            <dd>
              <input type="text" v-model="expertOffMatchingDTO.offlineName" />
            </dd>

            <dt>성별</dt>
            <dd class="rdo-gender">
              <div class="checkbox">
                <input type="radio" class="rdobox" id="rdo-1" v-model="expertOffMatchingDTO.offlineGender" :value="1" />
                <label for="rdo-1">남</label>
              </div>
              <div class="checkbox">
                <input type="radio" class="rdobox" id="rdo-2" v-model="expertOffMatchingDTO.offlineGender" :value="0" />
                <label for="rdo-2">여</label>
              </div>
            </dd>

            <dt>휴대폰번호</dt>
            <dd>
              <input type="text" v-model="expertOffMatchingDTO.offlinePhone" />
            </dd>

            <dt>생년월일</dt>
            <dd>
              <input type="date" v-model="expertOffMatchingDTO.offlineBirth" max="9999-12-31" />
            </dd>
          </dl>

          <div class="foot-btn">
            <button @click="postIntMatching">등록하기</button>
          </div>
        </div>
      </section>
      <!--<section class="btn-area">
            <button>확인</button>
        </section>-->
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, getCurrentInstance } from 'vue';

export default {
  name: 'modal-form-offline-client',
  description: '',
  props: {
    index: {
      type: [Number],
      default: 0
    },
    layout: {
      type: [Object],
      default: () => {}
    },
    data: {
      type: [Object],
      default: () => {}
    },
    callBack: {
      type: [Function],
      default: () => {}
    }
  },
  setup(props, context) {
    const { proxy } = getCurrentInstance();

    const state = reactive({
      expertOffMatchingDTO: {
        offlineName: '',
        offlineGender: 1,
        offlinePhone: '',
        offlineBirth: ''
      }
    });

    const fnClose = () => {
      context.emit('close', props.index);
    };
    const fnCallBack = (event) => {
      props.callBack(event);
    };

    const postIntMatching = async () => {
      if (proxy.$Util.isEmpty(state.expertOffMatchingDTO.offlineName)) {
        alert('성함을 입력해주세요.');
        return false;
      }
      if (proxy.$Util.isEmpty(state.expertOffMatchingDTO.offlinePhone)) {
        alert('휴대폰번호를 입력해주세요.');
        return false;
      }
      if (proxy.$Util.isEmpty(state.expertOffMatchingDTO.offlineBirth)) {
        alert('생년월일을 입력해주세요.');
        return false;
      }
      if (!confirm('저장하시겠습니까?')) return false;
      const expertOffMatchingDTO = proxy.$_.cloneDeep(state.expertOffMatchingDTO);
      expertOffMatchingDTO.offlineBirth = proxy.$dayjs(expertOffMatchingDTO.offlineBirth).format('YYYYMMDD');
      try {
        await proxy.$ManageSvc.postIntMatching(expertOffMatchingDTO);
        fnCallBack();
        fnClose();
      } catch (e) {
        console.error(e);
        if (e.data) {
          alert(e.data.message);
        }
      }
    };
    return {
      fnClose,
      fnCallBack,
      postIntMatching,
      ...toRefs(state)
    };
  }
};
</script>

<style scoped></style>
